function initParallax() {
    jarallax(document.querySelectorAll('.has-parallax-feed .gh-card'), {
        speed: 0.8,
    });
}

(function () {
    if (!document.body.classList.contains('has-background-about')) return;

    const about = document.querySelector('.gh-about');
    if (!about) return;

    const image = about.querySelector('.gh-about-image');

    if (!image.naturalWidth) {
        imagesLoaded(image, function () {
            about.style.setProperty('--about-height', image.clientWidth * image.naturalHeight / image.naturalWidth + 'px');
        });
    }
})();

(function () {
    initParallax();
})();

(function () {
    const toggle = document.querySelector('[data-toggle-comments]');
    if (!toggle) return;

    toggle.addEventListener('click', function () {
        document.body.classList.toggle('comments-opened');
    });
})();

(function () {
    const element = document.querySelector('.gh-article-excerpt');
    if (!element) return;

    let text = element.textContent;
    const emojiRE = /\p{EPres}|\p{ExtPict}/gu;

    const emojis = text.match(emojiRE);
    if (!emojis) return;

    emojis.forEach(function (emoji) {
        text = text.replace(emoji, `<span class="emoji">${emoji}</span>`);
    });

    element.innerHTML = text;
})();

(function () {
    pagination(true, initParallax);
})();

/* A11Y — Synchronise l’état aria-expanded du bouton burger avec l’ouverture/fermeture du menu mobile.
   Le toggle visuel (classe .gh-head-open ou équivalente) est géré par shared-theme-assets ;
   on ajoute ici uniquement la sémantique attendue par les lecteurs d’écran. */
(function () {
    const burger = document.querySelector('.gh-burger');
    if (!burger) return;

    function syncAriaExpanded() {
        const isOpen = document.body.classList.contains('gh-head-open');
        burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        burger.setAttribute('aria-label', isOpen ? 'Fermer le menu' : 'Ouvrir le menu');
    }

    // Observe les changements de classe sur <body> déclenchés par le toggle du menu
    const observer = new MutationObserver(syncAriaExpanded);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    // Synchronisation initiale
    syncAriaExpanded();
})();
